<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
	<template slot="bodyForm">
		<CLoader :pConfigLoad="ConfigLoad">
		<template slot="BodyFormLoad">
            <form id="FormAsignacion" role="form" method="post" autocomplete="off" onSubmit="return false">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        <h3>Datos De Configuración</h3>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                        <label>HOST</label>
                        <input v-model="proveedor.Host" placeholder="Ingrese el host, ejemplo (smtp.gmail.com)" type="text" class="form-control">
                        <label>
                            <CValidation v-if="this.errorvalidacion.Host" :Mensaje="'*'+errorvalidacion.Host[0]"></CValidation>
                        </label>
                    </div>

                    <div class="col-12 col-sm-12 col-md-1 col-lg-1 colxl-1">
                        <label>PUERTO</label>
                        <input v-model="proveedor.Port" placeholder="Ingrese el puerto, ejemplo (678)" type="text" class="form-control">
                        <label>
                            <CValidation v-if="this.errorvalidacion.Port" :Mensaje="'*'+errorvalidacion.Port[0]"></CValidation>
                        </label>
                    </div>   

                    <div class="col-12 col-sm-12 col-md-2 col-lg-2 colxl-2">
                        <label>ENCRIPTACIÓN</label>
                        <select v-model="proveedor.Encryption" class="form-control form-select">
                            <option value="">--Seleccionar--</option>
                            <option value="ssl">SSL</option>
                            <option value="tls">TLS</option>
                        </select>
                        <label>
                            <CValidation v-if="this.errorvalidacion.Encryption" :Mensaje="'*'+errorvalidacion.Encryption[0]"></CValidation>
                        </label>
                    </div>

                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 colxl-6">
                        <label>NOMBRE DEL SISTEMA <small>(Nombre que aparecerá en el correo)</small></label>
                        <input v-model="proveedor.NameApp" placeholder="Ingrese el nombre del sistema, ejemplo (Financiera F)" type="text" class="form-control">
                        <label>
                            <CValidation v-if="this.errorvalidacion.NameApp" :Mensaje="'*'+errorvalidacion.NameApp[0]"></CValidation>
                        </label>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 colxl-4">
                        <label>USUARIO</label>
                        <input v-model="proveedor.Username" placeholder="Ingrese el usuario, ejemplo (financieraF@gmail.com)" type="text" class="form-control">
                        <label>
                            <CValidation v-if="this.errorvalidacion.Username" :Mensaje="'*'+errorvalidacion.Username[0]"></CValidation>
                        </label>
                    </div>

                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 colxl-4">
                        <label>CONTRASEÑA</label>
                        <div class="input-icons">
                            <input v-model="proveedor.Password" :type="type" placeholder="Ingrese la contraseña, ejemplo (123financieraFPass)" class="form-control">
                            <button v-if="proveedor.Password !== ''" @click="ToggleShow" class="button btn-password-form-rec" type="button" id="button-addon2">
                                <i class="far icono-password" :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
                            </button>
                        </div>
                        <label>
                            <CValidation v-if="this.errorvalidacion.Password" :Mensaje="'*'+errorvalidacion.Password[0]"></CValidation>
                        </label>
                    </div>

                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 colxl-4">
                        <label>REMITENTE</label>
                        <input v-model="proveedor.Remitente" placeholder="Ingrese el usuario, ejemplo (financieraF@gmail.com)" type="text" class="form-control">
                        <label>
                            <CValidation v-if="this.errorvalidacion.Remitente" :Mensaje="'*'+errorvalidacion.Remitente[0]"></CValidation>
                        </label>
                    </div>
                </div>

                <div>
                    <CBtnSave :poBtnSave="oBtnSave" />
                </div>

            </form>
        </template>
		</CLoader>
	</template>
	</CList>
</template>

<script>

import moment from 'moment';

import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCorreo';

export default {
    name: 'FormCorreo',
    props: ['sFiltros','pOrigen'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Correo Electrónico',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                TitleFirst: '',
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            oBtnSave:{
                toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'panelSubMenus',
                EmitSeccion: EmitEjecuta,
            },
            proveedor: {
                IdMailServeConfig: 0,
                TipoServicio: '1',
                KeyService: 'PROVIDER',
                Driver: 'smtp',
                Host: '',
                Port: '',
                Username: '',
                Password: '',
                Encryption: '',
                Remitente: '',
                NameApp: '',
                Alias: 'Recuperar Contraseña'
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
            type: 'password',
            showPassword: false,
            password: null,
        }
    },
    methods: {
        async Guardar()
        {
            this.errorvalidacion     = [];
            this.oBtnSave.DisableBtn = true;

            await this.$http.put(`mailserviceconf/${this.proveedor.IdMailServeConfig}`, this.proveedor)
            .then( (res) => {
                this.proveedor = res.data.data;
                this.EjecutaConExito(res);
            })
            .catch( err => {
                this.EjecutaConError(err);
            });
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            //this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.$toast.success(res.data.message,'Tus datos de configuración han sido actualizados');
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        async InfoCorreo()
        {        
            let resquest = {
                KeyService: "PROVIDER"
            }

            this.$http.post("mailserviceconf", resquest).then( (res) => {
                this.proveedor  = res.data.data;
                this.segurity   = res.data.segurity;
            })
            .catch( err => {
                
                if(err.response.data.errors){
                    this.errorvalidacion=err.response.data.errors;
                } else {
                    this.$toast.error(err.response.data.message);
                }

            })
            .finally(() => {
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.proveedor = {
                IdMailServeConfig: 0,
                TipoServicio: '1',
                KeyService: 'PROVIDER',
                Driver: 'smtp',
                Host: '',
                Port: '',
                Username: '',
                Password: '',
                Encryption: '',
                Remitente: '',
                NameApp: '',
                Alias: 'Recuperar Contraseña'
            };

            this.errorvalidacion = [];
        },
        Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute,params:{}});
        },
        ToggleShow()
        {
            if (this.showPassword = !this.showPassword) {                    
                this.type = 'text'
            } else {
                this.type = 'password'
            }    
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        
        this.bus.$off('Save_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.InfoCorreo();
        this.ConfigLoad.ShowLoader = true;  
        this.oBtnSave.DisableBtn   = false;

        this.bus.$on('Save_'+EmitEjecuta,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
